<svg
  width="33"
  height="34"
  viewBox="0 0 33 34"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_5326)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.94137 4.59423C3.6146 4.50372 4.53631 4.5 6 4.5H27C28.4637 4.5 29.3854 4.50372 30.0586 4.59423C30.6815 4.67797 30.8239 4.80612 30.8839 4.86612C30.9439 4.92611 31.072 5.06848 31.1558 5.69137C31.2463 6.3646 31.25 7.28631 31.25 8.75V25.25C31.25 26.7137 31.2463 27.6354 31.1558 28.3086C31.072 28.9315 30.9439 29.0739 30.8839 29.1339C30.8239 29.1939 30.6815 29.322 30.0586 29.4058C29.3854 29.4963 28.4637 29.5 27 29.5H6C4.53631 29.5 3.6146 29.4963 2.94137 29.4058C2.31848 29.322 2.17611 29.1939 2.11612 29.1339C2.05612 29.0739 1.92797 28.9315 1.84423 28.3086C1.75372 27.6354 1.75 26.7137 1.75 25.25V8.75C1.75 7.28631 1.75372 6.3646 1.84423 5.69137C1.92797 5.06848 2.05612 4.92611 2.11612 4.86612C2.17611 4.80612 2.31848 4.67797 2.94137 4.59423ZM0 8.75C0 5.92157 0 4.50736 0.87868 3.62868C1.75736 2.75 3.17157 2.75 6 2.75H27C29.8284 2.75 31.2426 2.75 32.1213 3.62868C33 4.50736 33 5.92157 33 8.75V25.25C33 28.0784 33 29.4926 32.1213 30.3713C31.2426 31.25 29.8284 31.25 27 31.25H6C3.17157 31.25 1.75736 31.25 0.87868 30.3713C0 29.4926 0 28.0784 0 25.25V8.75Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_5326">
      <rect width="33" height="33" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
